import React, { FC } from 'react';
import { Table } from '@views/components/cart';
import { Block } from '@views/components/block/Block';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { Message, ContactProductMessage } from './message';
import TableItem from './item';
import GiftRow from './gift';

import { TABLE_HEADER } from '../../intl';

export type Props = {
  data: any[];
  gift?: any;
};

export const ProductList: FC<Props> = ({ data, gift }) => {
  const hasContactPrice = data.find((item) => get(item, 'isContactProduct'));

  return (
    <Block isSection>
      <Table>
        <Table.Head>
          <Table.Row>
            {/* <Table.Col as='th' heading checkbox>
              <form className="form-check">
                <input 
                  type="checkbox" 
                  className="form-check-input form-check__input"
                  value={1}
                  // style={{margin: 0}}
                  // onChange={handleChange} 
                />
              </form>
            </Table.Col> */}
            <Table.Col as="th" heading product>
              {TABLE_HEADER.PRODUCT}
            </Table.Col>
            <Table.Col as="th" heading price>
              {TABLE_HEADER.PRICE}
            </Table.Col>
            <Table.Col as="th" heading quantity>
              {TABLE_HEADER.QUANTITY}
            </Table.Col>
            <Table.Col as="th" heading total>
              {TABLE_HEADER.TOTAL}
            </Table.Col>
            <Table.Col as="th" heading action>
              {TABLE_HEADER.ACTION}
            </Table.Col>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {hasContactPrice && hasContactPrice.size > 0 && (
            <ContactProductMessage />
          )}
          <>
            {data.map((item) => (
              <TableItem key={get(item, 'id')} item={item} />
            ))}
          </>
          {!isEmpty(gift) && <GiftRow gift={gift} />}
          {/* <Message /> */}
        </Table.Body>
      </Table>
    </Block>
  );
};

export default ProductList;
